import type { Transaction } from '@shared/transactions-types';

export function getSecondaryId({
    partner,
    sender,
    receiver,
}: Transaction): Transaction['partner']['secondaryId'] {
    return partner?.secondaryId ?? sender?.secondaryId ?? receiver?.secondaryId;
}
